import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { resolveProductCategoryKey } from '../../../shared/helpers/resolve-product-category-key';
import { LevelProgressService } from '../../../shared/level-progress/level-progress.service';
import { OeAppPersonService } from '../../../shared/oe-app-person.service';
import { TranslationService } from '../../../shared/translation.service';
import { GamificationActivityType } from '../../../shared/types/gamification-activity-type';
import { ProgressBarInputData } from '../../../shared/types/ProgressBarInputData';

const TITLE_KEY = 'studybundle.liveClasses.titleText';

@Component({
  selector: 'lp2-live-class-header',
  template: `
    <lp2-study-bundle-child-header
      [title]="titleKey"
      [progressBarData]="liveClassProgressData$ | async"
    >
      <lp2-teacher-switch
        *ngIf="isSwitchVisible"
        [enabled]="isSwitchEnabled"
        [formControl]="teacherTypeControl"
      ></lp2-teacher-switch>
      <div class="d-flex flex-column align-items-md-end">
        <lp2-gamification-activity-points [points]="classesPoints"></lp2-gamification-activity-points>
      </div>
    </lp2-study-bundle-child-header>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassHeaderComponent implements OnInit {
  @Input() set activityPoints(value: Map<GamificationActivityType, number>) {
    this.classesPoints = value ? value.get(GamificationActivityType.COMPLETE_GROUP_CLASS) : 0;
  }

  @Input() public teacherTypeControl: FormControl;
  @Input() public isSwitchVisible: boolean;
  @Input() public isSwitchEnabled: boolean;

  public classesPoints: number;
  public liveClassProgressData$: Observable<ProgressBarInputData[]>;

  constructor(
    private levelProgressService: LevelProgressService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly translationService: TranslationService
  ) {}

  get titleKey(): string {
    return resolveProductCategoryKey(
      (key) => this.translationService.translate(key),
      this.oeAppPersonService.productCategory,
      TITLE_KEY
    );
  }

  ngOnInit() {
    this.liveClassProgressData$ = this.levelProgressService.liveClassLevelProgress$.pipe(
      map((liveClass) => [liveClass])
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-shared/live-class-header/live-class-header.component.ts